module.exports = __webpack_public_path__ + "static/img/mm4.cedb728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/mm4.jpg
// module id = GjwR
// module chunks = 2